import { createSlice } from '@reduxjs/toolkit';

import {
  loadInvestmentProjectsList,
  loadInvestmentProjectsItem,
} from './actions';
import { InvestmentProjectsState } from './interfaces';

export const investmentProjectsSlice = createSlice({
  name: 'investmentProjects',
  initialState: {
    list: [],
    item: null,
    limit: 20,
    total: 0,
    offset: 0,
  } as InvestmentProjectsState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(
      loadInvestmentProjectsList.fulfilled,
      (state, { payload: { data, total } }) => {
        state.list = data;
        state.total = total;
      }
    );
    builder.addCase(
      loadInvestmentProjectsItem.fulfilled,
      (state, { payload }) => {
        state.item = payload;
      }
    );
  },
});
